module.exports = __webpack_public_path__ + "fcb4bef5f0f18d129bcb05c5c40086bf.svg";